import React, { useEffect, useState } from 'react';
import { InfoBox } from '../../../components/InfoBox/InfoBox.component';
import { useStyles } from './HeaderCard.Styles';
import { ExaminerFunction } from '../Assessment.types';
import { CompleteSampleAssessmentProcess } from '../../../components/CompleteProcessZWO/CompleteSampleAssessmentProcess.component';
import { useExaminer } from '../../../Context/Examiner.context';
import { AssessmentSessionCloseability } from '../../../services/scoringModel/scoringModel.types';
import useDocumentTitle from '../../../hooks/DocumentTitle/documentTitle';
import { AssessmentSessionProcessTypeId } from '../../../services/exams/assessmentSession/assessments.types';
import { Typography } from '@material-ui/core';

interface HeaderCardProps {
  examinerName?: string;
  sessionName: string;
  isTeamList: boolean;
  isExaminerBlocked: boolean;
  processStatus?: AssessmentSessionCloseability;
  assessmentMode?: 'assessment' | 'sampleAssessment';
  onProcessClosed?: () => void;
  processTypeId?: AssessmentSessionProcessTypeId;
}

export const HeaderCard: React.FC<HeaderCardProps> = ({
  examinerName,
  sessionName,
  isTeamList = false,
  isExaminerBlocked,
  assessmentMode = 'assessment',
  processStatus,
  onProcessClosed,
  processTypeId,
}) => {
  const classes = useStyles();

  const [isInfoBoxDismissedAlready, setIsInfoBoxDismissedAlready] = useState<boolean>(false);
  const { examiner } = useExaminer();

  const mainHeader =
    assessmentMode === 'assessment'
      ? isTeamList
        ? 'Wykaz kart zespołu egzaminatorów:'
        : 'Wykaz ocenianych kart:'
      : isTeamList
      ? 'Wykaz kart zespołu wzorcowych ocen:'
      : 'Wykaz wyselekcjonowanych do oceny RGZ:';

  const getProcessLabel = (process?: AssessmentSessionProcessTypeId) => {
    switch (process) {
      case AssessmentSessionProcessTypeId.Qualification:
        return 'kwalifikacji';
      case AssessmentSessionProcessTypeId.Scoring:
        return 'oceniania';
      case AssessmentSessionProcessTypeId.Training:
        return 'ćwiczeniowy';
      default:
        return '';
    }
  };

  const documentTitle = processTypeId !== undefined
    ? `${mainHeader.slice(0, -1)} - proces ${getProcessLabel(processTypeId)}`
    : mainHeader.slice(0, -1);

  const sessionNameElement: JSX.Element = (
    <Typography variant='h2' className={classes.secondHeader}>
      <span>Sesja oceniania: </span>
      <span className={classes.spanHeader}>{sessionName}</span>
      {assessmentMode === 'sampleAssessment' &&
        examiner &&
        examiner?.function === ExaminerFunction.KK &&
        processStatus !== undefined &&
        onProcessClosed && (
          <CompleteSampleAssessmentProcess processStatus={processStatus} onProcessClosed={onProcessClosed} />
        )}
    </Typography>
  );

  useEffect(() => {
    setIsInfoBoxDismissedAlready(!isExaminerBlocked);
  }, [isExaminerBlocked]);

  useDocumentTitle(documentTitle);

  return (
    <header className={classes.header}>
      <h1 className={classes.mainHeader}>
        {mainHeader} {!isTeamList ? examinerName : ''}
      </h1>
      {sessionNameElement}
      {isExaminerBlocked && !isInfoBoxDismissedAlready && (
        <InfoBox
          type="error"
          message="Możliwość pobierania kart do oceny została zablokowana"
          onDismiss={() => {
            setIsInfoBoxDismissedAlready(true);
          }}
          style={{
            position: 'absolute',
            right: '35px',
          }}
        />
      )}
    </header>
  );
};
